module.exports = __webpack_public_path__ + "img/IMG_1578.c3aed588.jpeg";